import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

// this template needs to have a templateId of 5, this is an exception, not a rule
const InstitutionalGroup = () => {
	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'InstitutionalGroup',
		componentId: uuidv4(),
		templateId: 5,
		variables,
		props: FlexLayoutRow({
			blockClass: 'flex-row-container__inst-group-5',
			marginTop: { desktop: 8, tablet: 8, phone: 8 },
		}).props,
		childrenComponents: [
			FlexLayoutCol({ width: { desktop: '100%', mobile: '100%' } }, [
				VisibilityLayout({ mzTitle: 'MZ | Cabeçalho (On/Off)' }, [
					RichText({ blockClass: 'header__inst-group-5', text: '# Institucional' }),
				]),
				VisibilityLayout({ mzTitle: 'MZ | Corpo do texto (On/Off)' }, [
					RichText({
						blockClass: 'body__inst-group-5',
						text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
					}),
				]),
				VisibilityLayout({ mzTitle: 'MZ | Corpo do texto (On/Off)' }, [
					RichText({
						blockClass: 'body__inst-group-5',
						text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
					}),
				]),
				VisibilityLayout({ mzTitle: 'MZ | Corpo do texto (On/Off)' }, [
					RichText({
						blockClass: 'body__inst-group-5',
						text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
					}),
				]),
				VisibilityLayout({ mzTitle: 'MZ | Corpo do texto (On/Off)' }, [
					RichText({
						blockClass: 'body__inst-group-5',
						text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
					}),
				]),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [{ from: '--text-color-1', to: '--inst-group-5-text-color', name: 'Content' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xl', to: '--inst-group-5-content-header-d-fs', name: 'Content Header Desktop' },
			{ from: '--font-size-lg', to: '--inst-group-5-content-header-m-fs', name: 'Content Header Mobile' },
			{ from: '--font-size-sm', to: '--inst-group-5-content-fs', name: 'Content' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--inst-group-5-content-header-ff', name: 'Content Header' },
			{ from: '--main-font', to: '--inst-group-5-content-ff', name: 'Content' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xl', to: '--inst-group-7-content-header-d-fs', name: 'Content Header Desktop' },
			{ from: '--font-size-lg', to: '--inst-group-7-content-header-m-fs', name: 'Content Header Mobile' },
			{ from: '--font-size-sm', to: '--inst-group-7-content-fs', name: 'Content' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--inst-group-7-content-header-ff', name: 'Content Header' },
			{ from: '--main-font', to: '--inst-group-7-content-ff', name: 'Content' },
		],
	},
	{
		type: 'spacing',
		list: [{ from: '--spacing-nano', to: '--inst-group-7-content-gap', name: 'Content Gap' }],
	},
];
export default InstitutionalGroup;
